import { environment } from '../../environments/environment';
import { AuthService } from './auth-service.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NbToastrService, NbComponentStatus } from '@nebular/theme';
import { debug } from 'console';
import { alert } from 'devextreme/ui/dialog';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private userService: AuthService, public jwtHelperService: JwtHelperService, private toastrService: NbToastrService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let hasClaim: boolean = true;
    if (!!route.data['requiredClaim']) {
      let requiredClaim = route.data['requiredClaim'];
      this.userService.userHasClaim(requiredClaim);
      if (!this.userService.userHasClaim(requiredClaim)) {
        hasClaim = false;
      }
    }

    let hasRole: boolean = true;
    if (!!route.data['requiredRoles'] === true) {
      hasRole = (this.userService.userHasRole(route.data['requiredRoles']) || this.userService.userHasCustomerRole(route.data['requiredRoles']));
    }

    let hasSubscription: boolean = true;
    /*if (!!route.data['requiredSubscriptions'] === true){
      hasSubscription = this.userService.userHasSubscription(route.data['requiredSubscriptions']);
    }*/

    if ((!hasClaim || !hasRole || !hasSubscription) && !this.jwtHelperService.isTokenExpired()) {
      this.router.navigate(['pages', 'accessdenied']);
      return false;
    } else if (!this.jwtHelperService.isTokenExpired()) {
      return true;
    }

    localStorage.setItem('redirectUrl', state.url);
    if (this.jwtHelperService.getTokenExpirationDate() !== null && this.jwtHelperService.isTokenExpired()) {
      //this.toastrService.warning('De sessie is verlopen, je moet opnieuw inloggen.', 'Sessie is verlopen');
      alert('De sessie is verlopen, je moet opnieuw inloggen.', 'De sessie is verlopen').then(() => {
        this.userService.logout();
      });
    }
    this.router.navigate(['auth', 'login']);
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let hasClaim: boolean = true;
    if (!!route.data['requiredClaim']) {
      let requiredClaim = route.data['requiredClaim'];
      this.userService.userHasClaim(requiredClaim);
      if (!this.userService.userHasClaim(requiredClaim)) {
        hasClaim = false;
      }
    }

    let hasRole: boolean = true;
    if (!!route.data['requiredRoles'] === true) {
      hasRole = (this.userService.userHasRole(route.data['requiredRoles']) || this.userService.userHasCustomerRole(route.data['requiredRoles']));
    }

    let hasSubscription: boolean = true;
    /*if (!!route.data['requiredSubscriptions'] === true){
      hasSubscription = this.userService.userHasSubscription(route.data['requiredSubscriptions']);
    }*/

    if ((!hasClaim || !hasRole || !hasSubscription) && !this.jwtHelperService.isTokenExpired()) {
      this.router.navigate(['pages', 'accessdenied']);
      return false;
    } else if (!this.jwtHelperService.isTokenExpired()) {
      return true;
    }

    localStorage.setItem('redirectUrl', state.url);
    if (this.jwtHelperService.getTokenExpirationDate() !== null && this.jwtHelperService.isTokenExpired()) {
      //this.toastrService.warning();
      alert('De sessie is verlopen, je moet opnieuw inloggen.', 'De sessie is verlopen').then(() => {
        this.userService.logout();
      });
    }
    this.router.navigate(['auth', 'login']);
    return false;
  }
}
